<template>
    <swiper ref="mySwiper" :options="option" @mouseover.native="stopPlay" @mouseout.native="play">
        <swiper-slide v-for="(img, index) in imgs" :key="index">
            <img class="swiper-img" :src="img.url" @click="goto(img.action)" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            option: {
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    progressbarOpposite: true,
                    clickable: true
                }
            }
        };
    },
    props: ["imgs"],
    computed: {
        mySwiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    methods: {
        stopPlay() {
            this.mySwiper.autoplay.stop();
        },
        play() {
            this.mySwiper.autoplay.start();
        },
        goto(action) {
            this.$router.push(action)
        }
    },
    mounted() {
        let m = document.getElementsByClassName('swiper-pagination-bullet');
        for (let i = 0, l = m.length; i < l; i++) {
            m[i].onmouseover = function() {
                this.click()
            }
        }
    }
};
</script>

<style lang="scss">
.swiper-pagination-bullet {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #686868;
    margin: 0 20px !important;
    opacity: 1;
}
.swiper-pagination-bullet-active {
    background: #000000;
}
.swiper-img {
    width: 100%;
    cursor: pointer;
}
</style>